import React from 'react';
import { isFragment } from 'react-is';
export default function toArray(children) {
  var ret = [];
  React.Children.forEach(children, function (child) {
    if (child === undefined || child === null) {
      return;
    }

    if (Array.isArray(child)) {
      ret = ret.concat(toArray(child));
    } else if (isFragment(child) && child.props) {
      ret = ret.concat(toArray(child.props.children));
    } else {
      ret.push(child);
    }
  });
  return ret;
}


//////////////////
// WEBPACK FOOTER
// ./~/rc-util/es/Children/toArray.js
// module id = 447
// module chunks = 0